import { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@components/base';

import EditSearchQueryDialog from './EditSearchQueryDialog';

const ExportSearchQueryButton: FC = () => {
  const { t } = useTranslation();

  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Fragment>
      <IconButton
        icon='codeBracesBox'
        onClick={() => setDialogOpen(true)}
        title={t('searchQuery.edit')}
      />

      {dialogOpen && <EditSearchQueryDialog onClose={() => setDialogOpen(false)} />}
    </Fragment>
  );
};

export default ExportSearchQueryButton;
